/**
 * Gallery Slider Initialization
 * Initializes all Splide.js gallery sliders on the page
 * Works together with GLightbox for lightbox functionality
 */
document.addEventListener("DOMContentLoaded", function () {
    if (typeof Splide !== "undefined") {
        // Find all slider elements with data-slider-id attribute
        const sliderElements = document.querySelectorAll(
            '.splide[data-slider-id^="gallery-slider-"]'
        );

        if (sliderElements.length > 0) {
            sliderElements.forEach(function (sliderElement) {
                const sliderId = sliderElement.getAttribute("data-slider-id");
                const slideCount = sliderElement.querySelectorAll(".splide__slide").length;

                try {
                    const gallerySlider = new Splide("#" + sliderId, {
                        type: "slide",
                        rewind: false,
                        perPage: 3,
                        perMove: 1,
                        gap: "20px",
                        autoplay: false,
                        interval: 4000,
                        pauseOnHover: true,
                        speed: 600,
                        easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                        pagination: false,
                        arrows: slideCount > 3,
                        breakpoints: {
                            1200: {
                                perPage: 2,
                                perMove: 1,
                                gap: "20px",
                                arrows: slideCount > 2,
                            },
                            768: {
                                perPage: 1,
                                perMove: 1,
                                gap: "10px",
                                arrows: slideCount > 1,
                            },
                        },
                    });

                    gallerySlider.mount();
                    console.log(
                        "Gallery slider initialized successfully: #" + sliderId + " (" + slideCount + " slides)"
                    );
                } catch (error) {
                    console.error(
                        "Error initializing gallery slider #" + sliderId + ":",
                        error
                    );
                }
            });

            console.log(
                "Initialized " + sliderElements.length + " gallery slider(s)"
            );
        }
    } else {
        console.error("Splide.js library not loaded");
    }
});
